const CARDS = [
  {
    tag: '韩漫',
    title: '她的私密日记',
    desc: '一部细腻描绘都市女性内心世界的韩漫佳作，画风唯美，剧情引人入胜。',
    rating: '9.5',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20style%20illustration%20of%20a%20woman%20by%20the%20window%20at%20sunset%2C%20soft%20warm%20lighting%2C%20delicate%20fashion%2C%20emotional%20atmosphere%2C%20stylized%20flat%20illustration%2C%20coral%20and%20cream%20tones%2C%20no%20text%20no%20letters%2C%20modern%20aesthetic&width=600&height=420&seq=manga-card-01&orientation=landscape',
  },
  {
    tag: '日漫',
    title: '夏日幻梦物语',
    desc: '奇幻与现实交织的青春物语，日漫经典叙事风格搭配精良分镜，每一格都是壁纸。',
    rating: '9.3',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20summer%20scene%20with%20blue%20sky%20and%20fluffy%20clouds%2C%20school%20rooftop%2C%20warm%20golden%20sunlight%2C%20nostalgic%20atmosphere%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20soft%20and%20dreamy%20color%20palette&width=600&height=420&seq=manga-card-02&orientation=landscape',
  },
  {
    tag: '国漫',
    title: '长安幻夜行',
    desc: '古风悬疑国漫扛鼎之作，以盛唐为背景的奇幻探案故事，画风惊艳绝伦。',
    rating: '9.6',
    views: '156万',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20night%20cityscape%20with%20red%20lanterns%2C%20misty%20atmosphere%2C%20traditional%20architecture%2C%20warm%20golden%20light%20from%20lanterns%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20mysterious%20and%20elegant&width=600&height=420&seq=manga-card-03&orientation=landscape',
  },
  {
    tag: '韩漫',
    title: '办公室罗曼史',
    desc: '职场恋爱高甜韩漫，霸道总裁与职场新人的甜蜜碰撞，每周三更新不鸽。',
    rating: '9.1',
    views: '201万',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20interior%20with%20warm%20lighting%2C%20two%20coffee%20cups%20on%20desk%2C%20city%20view%20through%20large%20window%2C%20romantic%20atmosphere%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20soft%20coral%20and%20cream%20tones&width=600&height=420&seq=manga-card-04&orientation=landscape',
  },
  {
    tag: '悬疑',
    title: '第七层密室',
    desc: '豆瓣9分+悬疑漫画神作，层层嵌套的密室谜题，每话结尾都是高能反转。',
    rating: '9.7',
    views: '89万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20room%20with%20dramatic%20shaft%20of%20light%20from%20above%2C%20minimal%20furniture%2C%20suspenseful%20atmosphere%2C%20high%20contrast%20between%20light%20and%20shadow%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20cinematic%20noir%20aesthetic&width=600&height=420&seq=manga-card-05&orientation=landscape',
  },
  {
    tag: '搞笑',
    title: '废柴逆袭手册',
    desc: '全网爆笑指数第一的搞笑漫画，沙雕主角的逆袭之路，每天更新笑料不断。',
    rating: '9.0',
    views: '312万',
    image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20playful%20scene%20with%20comic%20pop%20art%20elements%2C%20fun%20energetic%20mood%2C%20vibrant%20orange%20yellow%20and%20coral%20colors%2C%20dynamic%20composition%2C%20stylized%20illustration%2C%20no%20text%20no%20letters%2C%20whimsical%20atmosphere&width=600&height=420&seq=manga-card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            编辑精选高分漫画，本本都是不可错过的佳作
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARDS.map((card, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`${card.title} - 谜妹漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-bold">
                    {card.rating}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.desc}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i>
                    推荐
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}